import React, {
  useState,
  useCallback,
  useRef,
  useEffect,
  useContext,
} from 'react';
import {Context} from '../AppContext';
import {Modal} from 'antd';
import {Close} from 'styled-icons/material';
import styled from 'styled-components';

const initialModal = {
  content: null,
  title: false,
  width: '400px',
  destroyOnClose: false,
};

function ModalContainer(props) {
  const app = useContext(Context);
  const [modal, setModal] = useState(initialModal);

  useEffect(() => {
    if (!app.state.modalContent) {
      setModal(initialModal);
    } else {
      setModal(app.state.modalContent);
    }
  }, [app.state.modalContent]);

  return (
    <StyledModal
      open={!!modal.content}
      onCancel={() => app.actions.setModal()}
      title={modal.title}
      footer={false}
      destroyOnClose={modal.destroyOnClose}
      closeIcon={
        <Close
          style={{
            position: 'absolute',
            right: 10,
            top: 6,
          }}
          size={24}
          color="#000"
        />
      }
      zIndex={15}
      width={modal.width}>
      {modal.content}
    </StyledModal>
  );
}

const StyledModal = styled(Modal)`
  .ant-modal-close {
    &:hover {
      background-color: transparent;
    }
  }

  .ant-modal-content {
    border-radius: 12px;
  }
  .ant-modal-header {
    padding: 16px 24px;
    border-radius: 10px 10px 0 0;
    border-bottom: none;
    .ant-modal-title {
      font-size: 20px;
      font-weight: 700;
      color: #000000;
      line-height: 1.5;
    }
  }
  .ant-modal-body {
    padding: 24px;
  }
  .ant-modal-footer {
    border-top: none;
  }
`;

export default ModalContainer;
